import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { Box, IconButton, Typography } from '@mui/material'

interface Props {
  label: string
  onBack: () => void
}

export default function Breadcrumb({ label, onBack }: Props) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        px: 1,
        py: 0.5,
        borderBottom: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.paper',
      }}
    >
      <IconButton onClick={onBack} size="small">
        <ArrowBackIcon fontSize="small" />
      </IconButton>
      <Typography variant="body2" sx={{ fontWeight: 600, color: 'text.secondary', ml: 0.5 }}>
        {label}
      </Typography>
    </Box>
  )
}
